import { useDefaultTimespan } from '~/components/date-picker'

import { Timespan } from '@hap/utils'

import { useCurrentUserSetting } from './useCurrentUserSetting'

interface UseTimespanPreferenceOptions {
  selectedTimespan?: Timespan.Info
  startOffset?: number | ((maxDate: Date) => Date)
}

export default function useTimespanPreference({
  selectedTimespan,
  startOffset,
}: UseTimespanPreferenceOptions = {}) {
  const defaultTimespan = useDefaultTimespan(startOffset)
  const [timespanPreference, setTimespanPreference] = useCurrentUserSetting<
    'lookup',
    'timespan',
    Timespan.Info | undefined
  >('lookup', 'timespan', defaultTimespan)

  const preferredTimespan = !timespanPreference?.type
    ? defaultTimespan
    : timespanPreference
  const timespan = selectedTimespan ?? preferredTimespan

  return {
    timespan,
    defaultTimespan,
    setTimespanPreference,
  }
}
